import SectionLabel from "@/components/base/SectionLabel";
import { businessToolData } from "@/mocks/businessToolData";

export default function DeliverablesSection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-8 md:mb-10 reveal">
          <SectionLabel
            label={businessToolData.deliverables.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4 md:mb-5">
            {businessToolData.deliverables.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {businessToolData.deliverables.description}
          </p>
        </div>

        <div className="max-w-4xl mx-auto reveal">
          <div className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
            <div className="bg-primary-500/[0.06] border-b border-background-200/70 px-5 md:px-7 py-4 flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary-500/10 flex items-center justify-center">
                <i className="ri-folder-3-line text-primary-500 text-lg" />
              </div>
              <div>
                <p className="text-sm font-bold text-foreground-900 font-heading">
                  開発後に残る資料一式
                </p>
                <p className="text-xs text-foreground-500">
                  仕様書、操作資料、業務フロー、管理情報が一つにつながる
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-y-0 sm:divide-x divide-background-200/50">
              {businessToolData.deliverables.categories.map((cat, idx) => (
                <div key={idx} className="p-5 md:p-6">
                  <div className="flex items-center gap-2.5 mb-3 pb-2 border-b border-background-200/50">
                    <div className="w-7 h-7 rounded-md bg-primary-500/10 flex items-center justify-center">
                      <i className={`${cat.icon} text-primary-500 text-sm`} />
                    </div>
                    <h3 className="text-sm font-bold text-foreground-900 font-heading">
                      {cat.title}
                    </h3>
                  </div>
                  <ul className="space-y-1.5">
                    {cat.items.map((item, i) => (
                      <li key={i} className="flex items-start gap-2 text-xs text-foreground-600">
                        <span className="w-1 h-1 rounded-full bg-primary-400 mt-2 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}